import {
  LOGGED_IN_CHECK_SUCCESS,
  LOGIN_SUCCESS,
  CREATE_ACCOUNT_SUCCESS,
  VERIFY_USER_SUCCESS
} from 'constants/actionTypes';

const initialState = null;

/**
 * Login reducer
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case LOGGED_IN_CHECK_SUCCESS:
    case VERIFY_USER_SUCCESS:
    case CREATE_ACCOUNT_SUCCESS:
      return action.user;

    default:
      return state;
  }
}
